/** Resolving the POS/online channels for the v1 menu screens.
 *
 * The rule, shared with the menu service and the v2 layout: a child's own block wins, a parent's
 * fills in only where the child has none, and absence means "not sold here" — which is what keeps
 * the setting opt-in. v2 already carries three copies of it; this is v1's one.
 */

/** An absent or empty block is not a channel. A form writes `{}` when it touches the object
 * without setting `enabled`, and reading that as a declaration would stop the parent's real
 * value being inherited. */
function declared(block: any): boolean {
	return block != null && typeof block === "object" && Object.keys(block).length > 0;
}

/** Whether an entity declares a channel of its own, rather than inheriting its parent's.
 * An unset child is not "off" — it is whatever its parent is. */
export function hasOwnChannel(conditions: any, channel: "pos" | "online" = "pos"): boolean {
	return declared(conditions?.[channel]);
}

/** The channel in force for an entity, given its ancestors nearest-first: a category takes its
 * menu's conditions, an item its category's and then its menu's. */
export function resolveChannel(
	channel: "pos" | "online",
	conditions: any,
	...ancestors: any[]
): boolean {
	for (const level of [conditions, ...ancestors]) {
		if (declared(level?.[channel])) return !!level[channel].enabled;
	}
	return false;
}

/** resolveChannel for the POS, which is the one that decides what reaches the terminal.
 *
 * A switch must show this rather than the raw field: drawing `conditions.pos.enabled` directly
 * shows an unset category as off while the service treats it as on, telling an operator their
 * category is off the POS while the terminal still sells it. */
export function resolvePosChannel(conditions: any, ...ancestors: any[]): boolean {
	return resolveChannel("pos", conditions, ...ancestors);
}
